module.exports = __webpack_public_path__ + "img/goal-seven-br.dec06fbf.png";